/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'

import Papa from 'papaparse';
import { useToast } from '../../../../../components/Toats';
import { StepperComponent } from '../../../../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../../../../_metronic/helpers';
import { LoadingSpan } from '../../../../../components/Loadings/loadingSpan';
import { useToastModal } from '../../../../../components/ToastModal';
import useSize from '../../../../../../hooks/useSize';
import { useAuth } from '../../../../../../modules/auth';
import { SelectGlobal } from '../../../../../components/SelectGlobal';
import { ModalCreatePlantComposite } from './components/ModalCreatePlantComposite';

type Props = {
    show: boolean;
    addValuesDataAll: any
    dataGlobal: any
    setDataGlobal: any
    addValuesDataAllStatus: any
    addValuesDataAllTypeImportation: any
    addValuesDataAllPlantComposite: any
    unit_branchs: any[]
    plantsComposite: any[]
    refreshPlants: any
    handleClose: () => void
}


const modalsRoot = document.getElementById('root-modals') || document.body

const ModalConfigurationsImported = ({
    show, 
    handleClose, 
    dataGlobal,
    setDataGlobal,
    addValuesDataAll, 
    addValuesDataAllStatus,
    addValuesDataAllTypeImportation,
    addValuesDataAllPlantComposite,
    unit_branchs,
    plantsComposite,
    refreshPlants

}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null);
  const stepper = useRef<StepperComponent | null>(null);
  const [loading, setLoading] = useState(false);
  const [loadingImported, setLoadingImported] = useState(false);
  const [dateImportationMonitor, setDateImportantionMonitor] = useState<any>();
  const { toggleToastModal } = useToastModal();
  const [inputControl, setInputControl] = useState(false);
  const {width: largura} = useSize();
  const {currentUser} = useAuth();

  const [showCreateAppModalImport, setShowCreateAppModalImport] = useState<boolean>(false)

  const fileInputRef : any = useRef(null);

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const closedClean = () => {
    handleClose()
    setDataGlobal(prev => ({
      ...prev,
      idUnitBranch: "",
      type_plano: "BASICA",
      type_importation: "SIMPLES"
    }));
  }


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-700px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Configurações de importação</span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column'
          id='kt_modal_create_app_stepper'
        >

            <div style={{marginBottom: '1rem'}}>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='text-body mt-1 fw-semibold fs-5'>Selecione o tipo de usina da importação: </span>
                    </h3>
                    <i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title='Período referente a data informada até o dia atual'
                    ></i>
                </label>  
                <div style={{display: 'flex', gap: '0.5rem', marginTop: '1rem'}}>
                    <div style={{display: 'flex', width: largura < 1200 ? '100%' : '', justifyContent: largura < 1200 ? "end" : "center", alignItems: 'center'}}>
                      <h3 style={{display: "flex", flexDirection: "column", alignItems: 'center', justifyContent: 'center'}}>
                          <span className='text-muted mt-1 fw-semibold fs-6'>SIMPLES</span>
                      </h3>
                      <div className={`form-check form-check-custom form-check-solid mx-5`}>
                          <input 
                          className={`form-check-input ${!inputControl ? 'bg-dark' : 'bg-primary'}`} 
                          type='checkbox'
                          //disabled={loading || loadingSubmit}
                          //value={typeImportation === "SIMPLES" ? true : false}
                          
                          checked={dataGlobal.type_importation === "SIMPLES" ? true : false}
                          onChange={(e) =>{
                              if(e.target.checked){
                                addValuesDataAllTypeImportation("SIMPLES")
                                addValuesDataAllPlantComposite(null)

                              }
                              //checkedAll(e.target.checked)
                              //setInputControl(e.target.checked)
                              //updateData(e.target.value, e.target.checked)
                          }} 
                          />
                      </div>
                    </div>

                    <div style={{display: 'flex', width: largura < 1200 ? '100%' : '', justifyContent: largura < 1200 ? "end" : "center", alignItems: 'center'}}>
                      <h3 style={{display: "flex", flexDirection: "column", alignItems: 'center', justifyContent: 'center'}}>
                          <span className='text-muted mt-1 fw-semibold fs-6'>COMPOSTA</span>
                      </h3>
                      <div className={`form-check form-check-custom form-check-solid mx-5`}>
                          <input 
                          className={`form-check-input ${!inputControl ? 'bg-dark' : 'bg-primary'}`} 
                          type='checkbox'
                          //disabled={loading || loadingSubmit}
                          //value={inputControl}
                          
                          checked={dataGlobal.type_importation === "COMPOSTA" ? true : false}
                          onChange={(e) =>{
                            if(e.target.checked){
                              addValuesDataAllTypeImportation("COMPOSTA")
                            }
                              //checkedAll(e.target.checked)
                              //setInputControl(e.target.checked)
                              //updateData(e.target.value, e.target.checked)
                          }} 
                          />
                      </div>
                    </div>
                </div>
            </div>
            
            <div className='separator my-2 mb-5'></div>

            {dataGlobal.type_importation === "SIMPLES" ?
              (<div style={{display: 'flex', flexWrap: 'wrap', gap: '1rem', flexDirection: 'column'}}>
                  <SelectGlobal 
                    itens={unit_branchs}
                    buttonAll={true}
                    textSearch={"Buscar unidade FILIAL"}
                    textButtonInit={"Selecione a FILIAL"}
                    labelKey='companyName'
                    valueKey='id'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/ecommerce/ecm009.svg'
                    sizeIconSvg='2'
                    value={dataGlobal.idUnitBranch}
                    className={"w-100"}
                    onChange={(value: string) => {
                      addValuesDataAll(value);
                      //setFilterCollaborator ? setFilterCollaborator(value) : console.log('Sem função de filtro')
                    }}
                  />

                  <SelectGlobal 
                    itens={[{value: 'PREMIUM'}, {value: 'STARTER'}, {value: 'BASICA'}]}
                    buttonAll={true}
                    textSearch={"Buscar plano"}
                    textButtonInit={"Selecione o plano"}
                    labelKey='value'
                    valueKey='value'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/general/gen063.svg'
                    sizeIconSvg='1'
                    //typeIcon='img'
                    value={dataGlobal.type_plano}
                    className={"w-100"}
                    onChange={(value: string) => {
                      addValuesDataAllStatus(value)
                        //setFilterCollaborator ? setFilterCollaborator(value) : console.log('Sem função de filtro')
                    }}
                  />
              </div>)
            :
              (<div style={{display: 'flex', flexWrap: 'wrap', gap: '1rem', flexDirection: 'column'}}>
                  
                <div className='w-100' style={{display: 'flex', gap: '1rem'}}>
                    <SelectGlobal 
                      itens={plantsComposite}
                      buttonAll={false}
                      textSearch={"Buscar usina COMPOSTA"}
                      textButtonInit={"Selecione a usina COMPOSTA"}
                      labelKey='name'
                      valueKey='id'
                      typeIcon='img'
                      linkIcon='https://res.cloudinary.com/deq3ehxe3/image/upload/v1763493847/plantComposite_r8bje0.png'
                      imageSize='25px'
                      //typeIcon='img'
                      value={dataGlobal.idParentPlant}
                      style={{flex: '7'}}
                      //className={"w-100"}
                      onChange={(value: string) => {
                          addValuesDataAllPlantComposite(value);
                          //setFilterCollaborator ? setFilterCollaborator(value) : console.log('Sem função de filtro')
                      }}
                    />
                    <a
                      onClick={() =>{
                        setShowCreateAppModalImport(true)
                      }}
                      style={{flex: '3', display: 'flex', gap: '0.2rem', alignItems: 'center' }}
                      href='#'
                      className='btn btn-sm btn-light-primary'
                    //data-bs-target='#kt_modal_create_unitBranch'

                    >
                      <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                      <span>Nova Usina COMPOSTA</span>
                    </a>
                </div>

                <SelectGlobal 
                    itens={unit_branchs}
                    buttonAll={false}
                    textSearch={"Buscar unidade FILIAL"}
                    textButtonInit={"Selecione a FILIAL"}
                    labelKey='companyName'
                    valueKey='id'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/ecommerce/ecm009.svg'
                    sizeIconSvg='2'
                    value={dataGlobal.idUnitBranch}
                    className={"w-100"}
                    onChange={(value: string) => {
                      addValuesDataAll(value);
                      //setFilterCollaborator ? setFilterCollaborator(value) : console.log('Sem função de filtro')
                    }}
                  />

                  <SelectGlobal 
                    itens={[{value: 'PREMIUM'}, {value: 'STARTER'}, {value: 'BASICA'}]}
                    buttonAll={false}
                    textSearch={"Buscar plano"}
                    textButtonInit={"Selecione o plano"}
                    labelKey='value'
                    valueKey='value'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/general/gen063.svg'
                    sizeIconSvg='1'
                    //typeIcon='img'
                    value={dataGlobal.type_plano}
                    className={"w-100"}
                    onChange={(value: string) => {
                      addValuesDataAllStatus(value)
                        //setFilterCollaborator ? setFilterCollaborator(value) : console.log('Sem função de filtro')
                    }}
                  />
              </div>)
            }
        </div>
      </div>

      <div className='modal-footer'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <button
              type='button'
              className='btn btn-lg btn-light'
              disabled={loading}
              onClick={() => {
                closedClean()
              }}
          >
              <KTSVG
                path='/media/icons/duotune/arrows/arr063.svg'
                className='svg-icon-3 ms-2 me-0'
              />
              <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
              
          </button>

          <button
              type='button'
              className='btn btn-lg btn-primary'
              disabled={loadingImported}
              onClick={closed}
          >
              Confirmar
          </button>
        </div>

        <ModalCreatePlantComposite 
          show={showCreateAppModalImport}
          handleClose={() => {
            setShowCreateAppModalImport(false)
            refreshPlants()
          }} 
        />
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalConfigurationsImported}
